<template>
  <div class="sms_logo_div">
    <a v-for="(sns, idx) in snsList" :key="idx" :href="sns.link" class="sms_logo" :style="`background-image:url('images/basic/icon/${sns.icon}')`"></a>
  </div>  
</template>

<script>
import { fetchMainCommonInfo } from '@/api/info'
export default {
  created() {
   fetchMainCommonInfo()
   .then(({ data }) => {
    this.snsList = data.result.snsList
   })
  },
  data() {
    return {
      snsList: [],
    }
  },
}
</script>

<style>

</style>